import * as React from 'react';
import styled from 'styled-components';
import { PageHeader, Button, Title, Icon, theme } from 'components';

const NewGroupsHeader: React.FC<{
  save: () => Promise<void>;
  back: () => void;
  isLoading: boolean;
}> = ({ save, back, isLoading }) => (
    <StyledPageHeader
      ghost={false}
      onBack={back}
      backIcon={<Icon color="black" type="antdLeftOutlined" />}
      title={<Title level={1}>Groups</Title>}
      extra={
        <>
          <Button onClick={back}>Cancel</Button>
          <Button loading={isLoading} onClick={save} type="primary">
            Save
          </Button>
        </>
      }
    />
  );

export default NewGroupsHeader;

const StyledPageHeader = styled(PageHeader)`
  border-top: 1px solid ${theme.gray4};
  ${Title} {
    margin-bottom: 0;
  }
`;
